// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"7703f4c0","411":"4c3f23bd","488":"bbe79265","562":"54dff17a"}[chunkId] + ".chunk.js";
};